// lib/seo.ts

// Absolute last-resort metadata: no baseUrl, no headers, nothing that can
// throw. Any generateMetadata that hits an unexpected error should fall back
// to this instead of letting the error bubble up and leave the page
// "Untitled" in search results.
export const FALLBACK_SEO = {
  title: 'Greet - Discover The Best Local Events & Popular Events',
  description:
    'Best events including Live Comedy, Music, Food, Exhibitions, Festivals, Workshops & Travel.',
  applicationName: 'Greet',
};

export async function defaultSEO({ baseUrl }: { baseUrl: string }) {
  // baseUrl comes from request headers - guard the one call that can throw
  // (an invalid/missing host) so this never leaves a page without metadata.
  let metadataBase: URL | undefined;
  try {
    metadataBase = new URL(baseUrl);
  } catch {
    metadataBase = undefined;
  }

  return {
    ...(metadataBase && { metadataBase }),
    title: 'Greet - Discover The Best Local Events & Popular Events',
    description:
      'Best events including Live Comedy, Music, Food, Exhibitions, Festivals, Workshops & Travel.',
    applicationName: 'Greet',
    authors: [{ name: 'Greet Team', url: 'https://greet.fydo.in' }],
    creator: 'Greet Team',
    publisher: 'Greet',
    keywords:
      'event booking, book event online, local events, discover events, wedding venues, party planner, live comedy shows, food festivals, travel events, book workshops, music events near me, greet, fydo, best events in city, online event booking, concert tickets, event platform, Greet app',
    openGraph: {
      type: 'website',
      siteName: 'Greet',
      title: 'Greet - Discover The Best Local Events & Popular Events',
      url: baseUrl,
      description:
        'Best events including Live Comedy, Music, Food, Exhibitions, Festivals, Workshops & Travel.',
      locale: 'en_US',
      images: [
        {
          url: `${baseUrl}/ogImage2.png`,
          secureUrl: `${baseUrl}/ogImage2.png`,
          width: 1200,
          height: 630,
          alt: 'Greet by Fydo',
        },
      ],
    },
    twitter: {
      title: 'Greet - Discover The Best Local Events & Popular Events',
      description:
        'Best events including Live Comedy, Music, Food, Exhibitions, Festivals, Workshops & Travel.',
      card: 'summary_large_image',
      images: [`${baseUrl}/ogImage2.png`],
    },
    appleWebApp: {
      capable: true,
      statusbar: 'black',
      title: 'Greet by Fydo',
    },
  };
}
